module.exports = __webpack_public_path__ + "static/media/dam.b2a7fdcf.svg";